export default __webpack_public_path__ + "static/media/whatsapp.c7ffea3c.svg";